import { render } from "./BuyMercadoPago.vue?vue&type=template&id=3b1da48f"
import script from "./BuyMercadoPago.vue?vue&type=script&lang=js"
export * from "./BuyMercadoPago.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__